module.exports = __webpack_public_path__ + "img/crown-white.3fe94a8c.svg";